(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('UserFeedback', UserFeedback);

    UserFeedback.$inject = ['$resource'];

    function UserFeedback ($resource) {
        var resourceUrl =  'api/user-feedbacks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
